import { z } from 'zod';
import type { CategoriaExigencia, SituacaoLeitura, TipoDocumentoIa, TipoPrazo } from '../enums/dominios';

// O edital da licitação lido pela IA (base comum, ADR-0019), visto de dentro do processo: tudo com a origem
// (documento, página e trecho) para a pessoa conferir.

export type OrigemDto = { documento: string | null; pagina: number | null; trecho: string | null };

export type CampoEditalDto = OrigemDto & { campo: string; rotulo: string; valor: string; confirmado: boolean };
export type ItemEditalDto = OrigemDto & {
  lote: string | null;
  numero: string | null;
  quantidade: number | null;
  unidade: string | null;
  descricao: string;
  valorUnitario: number | null;
  descricaoImagem: string | null;
};
export type ExigenciaEditalDto = OrigemDto & { categoria: CategoriaExigencia; descricao: string };
export type PrazoEditalDto = OrigemDto & { tipo: TipoPrazo; descricao: string; data: string | null };
export type DocumentoEditalDto = {
  uuid: string;
  nome: string;
  tipo: TipoDocumentoIa | null;
  paginas: number | null;
  situacao: SituacaoLeitura;
  secoes: { titulo: string; paginaInicial: number; paginaFinal: number }[];
};

export type EditalDto = {
  situacao: SituacaoLeitura;
  resumo: string | null;
  campos: CampoEditalDto[];
  itens: ItemEditalDto[];
  exigencias: ExigenciaEditalDto[];
  prazos: PrazoEditalDto[];
  documentos: DocumentoEditalDto[];
};

/** Rótulos dos campos da ficha, na ordem em que aparecem. */
export const ROTULOS_CAMPOS_EDITAL: Record<string, string> = {
  orgao: 'Órgão',
  municipio: 'Município',
  uf: 'UF',
  modalidade: 'Modalidade',
  numero: 'Número',
  numero_processo: 'Processo',
  objeto: 'Objeto',
  criterio_julgamento: 'Critério de julgamento',
  valor_estimado: 'Valor estimado',
  data_sessao: 'Sessão pública',
  portal: 'Portal',
  link: 'Link',
  prazo_execucao: 'Prazo de execução',
  vigencia: 'Vigência',
  validade_proposta: 'Validade da proposta',
  garantia: 'Garantia',
  tratamento_me_epp: 'ME/EPP',
  consorcio: 'Consórcio',
  visita_tecnica: 'Visita técnica',
  amostra: 'Amostra',
};

// Perguntas ao edital (RAG): resposta só com base nos documentos, sempre com citação.

export const esquemaPergunta = z.object({ pergunta: z.string().trim().min(3).max(1000) });
export type PerguntaEntrada = z.infer<typeof esquemaPergunta>;

export type CitacaoDto = { documento: string; pagina: number; trecho: string };
/** `resposta` null sem IA: vêm só os trechos encontrados. */
export type RespostaPerguntaDto = { resposta: string | null; semBase: boolean; citacoes: CitacaoDto[] };

/** Frase obrigatória quando os documentos não sustentam a resposta (regra 6 do projeto). */
export const SEM_BASE_DOCUMENTAL = 'Não encontrei base documental suficiente para responder com segurança.';
